import React from "react";
import { Box, Typography, Popover, useTheme, useMediaQuery } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const categories = [
  { name: "Resort", img: `https://media.istockphoto.com/id/641448082/photo/beautiful-tropical-beach-front-hotel-resort-with-swimming-pool-sunshine.jpg?s=612x612&w=0&k=20&c=9PyitcP743oS7oGAoSW8iGDjf1goapy40Ol7PcCNv24=` },
  { name: "House", img: "https://media.istockphoto.com/id/856794670/photo/beautiful-luxury-home-exterior-with-green-grass-and-landscaped-yard.jpg?s=612x612&w=0&k=20&c=Jaun3vYekdy6aBcqq5uDQp_neNp5jmdLZXZAqqhcjk8=" },
  { name: "Apartment", img: "https://images.pexels.com/photos/439391/pexels-photo-439391.jpeg" },
  { name: "Tent", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR4T9yfdJwXdWBNaSO4YsBZqLrWTSOUgG7DI6qCUPx2yg0_ocU06erMXp0HzdmPGLdFJRE&usqp=CAU" },
];

export default function CategoryDropdown() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedCategory, setSelectedCategory] = React.useState(null);
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const theme = useTheme();

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleSelect = (category) => {
    setSelectedCategory(category);
    handleClose();
  };

  const open = Boolean(anchorEl);
  const id = open ? "category-popover" : undefined;

  return (
    <div>
      {/* Dropdown Button */}
      <Box
        aria-describedby={id}
        onClick={handleClick}
        sx={{
          width: isSmallScreen ? "100%" : "220px",
          p: 1.5,
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#FFFFFF",
          borderRadius: "12px",
          border: "1px solid #D6DAC8",
          transition: "0.2s ease-in-out",
          "&:hover": {
            boxShadow: "0px 3px 8px rgba(0,0,0,0.08)",
          },
        }}
      >
        <Box>
          <Typography
            sx={{
              fontSize: "11px",
              fontWeight: 500,
              color: "#6B7280",
            }}
          >
            CATEGORY
          </Typography>

          <Typography
            sx={{
              fontSize: "1rem",
              fontWeight: 600,
              color: "#111827",
            }}
          >
            {selectedCategory ? selectedCategory.name : "Select Category"}
          </Typography>
        </Box>

        <KeyboardArrowDownIcon
          sx={{
            fontSize: "1.7rem",
            color: theme?.palette?.text?.primary || "#374151",
          }}
        />
      </Box>

      {/* Dropdown Popover */}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{
          sx: {
            borderRadius: "14px",
            boxShadow: "0px 6px 18px rgba(0,0,0,0.12)",
            width: 350,
            maxWidth: "90vw",
          },
        }}
      >
        <Box sx={{ p: 2 }}>
          {categories.map((category) => {
            const isActive = selectedCategory?.name === category.name;

            return (
              <Box
                key={category.name}
                onClick={() => handleSelect(category)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  mb: 1.5,
                  p: 1.2,
                  borderRadius: "10px",
                  cursor: "pointer",
                  transition: "0.25s",
                  backgroundColor: isActive ? "#FCB53B" : "#fff",
                  color: isActive ? "#000" : "#111",
                  boxShadow: isActive
                    ? "0px 2px 6px rgba(0,0,0,0.10)"
                    : "none",
                  "&:hover": {
                    backgroundColor: isActive ? "#FBB040" : "#f8f8f8",
                  },
                }}
              >
                <Box
                  component="img"
                  src={category.img}
                  alt={category.name}
                  sx={{
                    width: 60,
                    height: 60,
                    borderRadius: "10px",
                    objectFit: "cover",
                    mr: 2,
                  }}
                />

                <Typography sx={{ fontSize: "1rem", fontWeight: 600 }}>
                  {category.name}
                </Typography>
              </Box>
            );
          })}
        </Box>
      </Popover>
    </div>
  );
}

